import React from 'react';
import Button from 'components/UI/Button';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { Space } from 'styles/themeSpaces';
import { Main } from 'styles/themeColors';
import { CREDIT_BUTTONS } from 'constants/credit';

export interface CreditActionButtonsProps {
  onCancel: () => void;
  onApply: () => void;
  disabled?: boolean;
  padding?: string;
}

/**
 * Reusable credit action buttons component
 * Provides consistent Cancel/Apply button styling and layout
 */
const CreditActionButtons: React.FC<CreditActionButtonsProps> = ({
  onCancel,
  onApply,
  disabled = false,
  padding
}) => {
  return (
    <FlexboxContainer gap={Space.spBase} padding={padding}>
      <Button 
        onClick={onCancel}
        bgColor={Main.white}
        borderColor={Main.lightGray}
        color={Main.black}
        disabled={disabled}
      >
        {CREDIT_BUTTONS.CANCEL}
      </Button>
      <Button 
        onClick={onApply}
        bgColor={Main.black}
        borderColor={Main.black}
        color={Main.white}
        disabled={disabled}
      >
        {CREDIT_BUTTONS.APPLY}
      </Button>
    </FlexboxContainer>
  );
};

export default CreditActionButtons;